import { CheckItem, CheckType, HazardLevel } from '@/types'
import { v4 as uuidv4 } from 'uuid'

// 瓶装液化石油气常见隐患
const liquefiedGasHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  {
    name: '使用无熄火保护装置燃气灶具',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB55009-2021）6.2.5条',
  },
  {
    name: '用气房间设置气化器',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》（GB 51142-2015）7.0.4条',
  },
  {
    name: '公共用餐区域设置气瓶',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）6.2.3条',
  },
  {
    name: '大中型商店建筑内使用液化石油气气瓶',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）6.2.3条',
  },
  {
    name: '气瓶加热使用',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB55009-2021）第6.1.10条',
  },
  {
    name: '气瓶横卧、倒卧使用',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB55009-2021）第6.1.10条',
  },
  {
    name: '使用可调式调压器',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《瓶装液化石油气调压器》（GB35844-2018）第5.2.1.3条',
  },
  {
    name: '灶具连接使用橡胶软管',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB55009-2021）6.1.7条',
  },
  {
    name: '软管中间有接口、三通等',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB55009-2021）6.1.8条',
  },
  {
    name: '未安装燃气泄漏报警器，或安装不规范',
    checkType: CheckType.LIQUEFIED_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《中华人民共和国安全生产法》第三十六条；《燃气工程项目规范》（GB55009-2021）6.2.1条',
  },
]

// 管道天然气常见隐患
const naturalGasHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  {
    name: '用户支管阀前管道有漏气现象',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》（CJJ 51-2016）第5.3.4条',
  },
  {
    name: '室内燃气管道末端未有效封堵',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》（CJJ 51-2016）第5.3.4条',
  },
  {
    name: '用户擅自安装、改装、拆除燃气管道及附件',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气管理条例》（国务院令第583号，2016年修订）第二十八条第（四）项',
  },
  {
    name: '灶具连接软管使用橡胶软管',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）第6.1.7条',
  },
  {
    name: '使用无熄火保护装置燃气灶具',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）第6.2.5条',
  },
  {
    name: '同一用气场所，储存、使用两种或两种以上燃料',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》（GB 50028-2006，2020年版）第10.5.2条',
  },
  {
    name: '未安装燃气泄漏报警器，或安装间距、安装高度不符合要求',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气报警控制系统技术规程》（CJJ/T 146-2011）第3.2.4条',
  },
  {
    name: '未设置与燃气浓度检测报警器连锁的紧急切断阀',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）第6.2.1条',
  },
  {
    name: '商业燃具或用气设备未设置在通风良好、符合安全使用条件且便于维护操作的场所',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）第6.2.1条',
  },
  {
    name: '商业建筑内的用气场所燃气进口和燃具前管道上未单独设置阀门或无明显的启闭标记',
    checkType: CheckType.NATURAL_GAS,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《燃气工程项目规范》（GB 55009-2021）第6.2.6条',
  },
]

// 液化石油气储配站隐患（表二）
const lpgDepotHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  // 周边环境与总平布置
  {
    name: '站内、外防火间距不符合规范要求',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '空瓶或实瓶未按原设计位置堆放',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '生产区四周未设不低于2m的不燃烧实体围墙，或围墙破损',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '生产区内存在地下、半地下空间（电缆沟等未用细砂填满）',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '生产区内种植油性植物或易燃植物未清除，防护堤内有绿化',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  // 站区管理
  {
    name: '控制系统未启用，储罐压力与液位报警参数设置不符合设计要求',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '可燃气体报警控制系统指示报警设备未设置在有人值守场所，或设备工作异常',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '进入生产区车辆未安装阻火器，或携带非防爆型电子设备和火种入场',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '未安装视频监控，或视频监控未覆盖站区',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '生产区入口处未安装人体静电消除装置',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '未在各岗位醒目位置悬挂岗位职责、操作规程和应急处置措施',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《安全生产法》第41条',
  },
  // 装卸区
  {
    name: '装卸装置未设置拉断阀',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '液相管道相邻两切断阀之间或切断阀后封闭管道未设置安全阀',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '汽车槽车装卸未采用万向充装管道系统（鹤管、装卸臂）',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '装卸区未设置固定式可燃气体探测器',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '爆炸危险区域内电气、仪表装置不具备相应防爆性能',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '槽车、卸液台柱无接地线或接地线故障',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '管道无流向标识，阀门未悬挂开关状态标志牌',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  // 储罐区
  {
    name: '储罐未设置压力仪表或不具备超限报警功能',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '储罐未设置液位监测装置或不具备超限报警功能',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '储罐未设置安全阀，或容积≥100m³的储罐安全阀少于2个',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '储罐出液口、气相口未设置紧急切断阀',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '储罐区未设置固定式可燃气体探测器',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '安全阀未垂直安装，铅封不完整，或无检验标牌',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '总容积>50m³或单罐>20m³地上储罐未设喷淋系统',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '储罐外壁漆膜脱落、凹陷或存在异常结霜现象',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《液化石油气供应工程设计规范》GB 51142',
  },
  {
    name: '特种设备显著位置未张贴使用标志或不清晰',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《特种设备安全法》',
  },
  // 检测检验
  {
    name: '压力容器、管道无使用登记证或全面检验报告超期',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016 §7.5',
  },
  {
    name: '安全阀校验报告超期或未校验',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016',
  },
  {
    name: '防雷、防静电检测不在有效期内',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  {
    name: '可燃气体检测报警器未检定或检定证书超期',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《计量法》',
  },
  {
    name: '防爆电气检测合格证未在有效期内',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '灭火器压力指针不在绿色区域或无定期检查记录',
    checkType: CheckType.LPG_DEPOT,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《建筑灭火器配置设计规范》GB 50140',
  },
]

// LNG 气化站隐患（表五）
const lngGasificationHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  // 周边环境及平面布置
  {
    name: '储罐与站外建构筑物防火间距不符合GB 50028或GB 50183的规定',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028；《石油天然气工程设计防火规范》GB 50183',
  },
  {
    name: '进出场站外部道路宽度小于4m',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '生产区与辅助区未用实体墙隔开，或辅助区有危险物品存放',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '生产区消防车道宽度不足或尽头式消防车道回车场不符合要求',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  // 站区管理
  {
    name: '控制系统未启用，储罐压力与液位报警参数设置不符合设计要求',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '仪表控制系统未配备UPS不间断电源',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '可燃气体报警控制系统指示报警设备未设置在有人值守场所，或设备工作异常',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '进入生产区人员未穿防静电工作服或携带非防爆型设备',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《安全生产法》',
  },
  {
    name: '未安装视频监控或视频监控未覆盖站区',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  // 储罐区
  {
    name: '储罐区未设置固定式可燃气体探测器',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《液化天然气（LNG）生产、储存和装运》GB/T 20368',
  },
  {
    name: '爆炸危险区域内电气、仪表装置不具备相应防爆性能',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '储罐未设置压力检测装置或不具备超限报警功能',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐未设置液位监测装置或不具备超限报警功能，运行液位超限',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐安全阀未采用奥氏体不锈钢弹簧封闭全启式，或容积≥100m³未设2个安全阀',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '液相管道相邻两切断阀之间的封闭管道未设安全阀',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐液相进、出口管上未设紧急切断阀或未与液位联锁',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '真空绝热罐无真空表接口或无定期真空检验记录',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐外壁有凹陷或异常结霜现象',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐区未设置低温报警探头',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '储罐钢筋混凝土基础有裂缝、剥蚀或立式罐异常倾斜',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  // 气化及调压装置区
  {
    name: '气化器结霜严重，换热效率异常',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '低温管道保冷层破损、脱落',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB/T 20368',
  },
  {
    name: '调压后管道未设置安全阀',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '调压装置未设置紧急切断阀',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '放散管管口高度不符合规范要求',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '防雷、防静电接地装置缺失或连接不完整',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  // 检测检验
  {
    name: '压力容器、管道无使用登记证或全面检验报告超期',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016 §7.5',
  },
  {
    name: '安全阀校验报告超期或未校验',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016',
  },
  {
    name: '防雷、防静电检测合格报告不在有效期内',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  {
    name: '可燃气体检测报警器未检定或检定证书超期',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《计量法》',
  },
  {
    name: '防爆电气检测合格证未在有效期内',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '灭火器压力指针不在绿色区域或无定期检查记录',
    checkType: CheckType.LNG_GASIFICATION,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《建筑灭火器配置设计规范》GB 50140',
  },
]

// LNG 加气站隐患（表七）
const lngFillingHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  // 周边环境及平面布置
  {
    name: '站内、外安全间距不符合《汽车加油加气加氢站技术标准》GB 50156的规定',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《汽车加油加气加氢站技术标准》GB 50156',
  },
  {
    name: '站区围墙高度低于2.2m或破损',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '车辆入口与出口未分开，或无明显标识牌',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  // 站区管理
  {
    name: '控制系统未启用，储罐压力与液位报警参数设置不符合设计要求',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '仪表控制系统未配备UPS不间断电源',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '可燃气体报警控制系统指示报警设备未设置在有人值守场所，或设备工作异常',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '进入生产区人员未穿防静电工作服或携带非防爆型设备',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《安全生产法》',
  },
  {
    name: '未安装视频监控或视频监控未覆盖站区',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  // 卸车区
  {
    name: '爆炸危险区域内电气、仪表装置不具备相应防爆性能',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '液相管道相邻两切断阀之间的封闭管道未设安全阀',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '装卸臂或卸车软管上未设置拉断阀',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '卸车软管未采用奥氏体不锈钢波纹软管，有裂纹现象，无半年耐压试验记录',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '静电接地线在装卸时与槽车未有效连接',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '槽车停靠区地面无清晰的停车位标线或无防撞柱',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '管道无流向标识，阀门未悬挂开关状态标志牌',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  // 储罐区
  {
    name: '储罐区未设置固定式可燃气体探测器',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐未设置压力检测装置或不具备超限报警功能',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐未设置液位监测装置或不具备超限报警功能',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐液相进、出口管上未设紧急切断阀或未与液位联锁',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '真空绝热罐无真空表接口或无定期真空检验记录',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐外壁有凹陷或异常结霜现象',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐安全阀未采用奥氏体不锈钢弹簧封闭全启式或铅封不完整',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '储罐基础有裂缝、剥蚀或立式罐异常倾斜',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '低温管道保冷层破损、脱落',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  {
    name: '防雷、防静电接地装置缺失或连接不完整',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  // 加气区
  {
    name: '加气机区域爆炸危险区域内电气不具备防爆性能',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50058',
  },
  {
    name: '加气机区域未设置固定式可燃气体探测器',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'GB 50156',
  },
  // 检测检验
  {
    name: '压力容器、管道无使用登记证或全面检验报告超期',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016 §7.5',
  },
  {
    name: '安全阀校验报告超期或未校验',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016',
  },
  {
    name: '防雷、防静电检测合格报告不在有效期内',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  {
    name: '可燃气体检测报警器未检定或检定证书超期',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《计量法》',
  },
  {
    name: '灭火器压力指针不在绿色区域或无定期检查记录',
    checkType: CheckType.LNG_FILLING,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《建筑灭火器配置设计规范》GB 50140',
  },
]

// 天然气门站/调压站隐患（表四 + 表八）
const gatePressureHazards: Omit<CheckItem, 'id' | 'createdAt'>[] = [
  // 周边环境及平面布置
  {
    name: '工艺设施、放散管与站外建构筑物防火间距不符合GB 50028的规定',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '进出场站外部道路宽度小于4m',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '站内露天工艺装置、放散管与站内建构筑物防火间距不符合GB 50016和GB 50028',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028；《建筑设计防火规范》GB 50016',
  },
  {
    name: '生产区和辅助区未进行功能分区，辅助区内有危险物品存放',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '围墙高度低于2m或破损丧失功能',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '生产区内种植油性植物，秋冬季节干枯易燃植物未清除',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  // 站区管理
  {
    name: '仪表控制系统未配备UPS不间断电源',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '可燃气体报警控制系统指示报警设备未设置在有人值守场所，或设备工作异常',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '进入生产区人员未穿防静电工作服或携带非防爆型设备',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《安全生产法》',
  },
  {
    name: '未安装视频监控和周界报警设施，或设施失效',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '未在各岗位醒目位置悬挂岗位职责、操作规程和应急处置措施',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《安全生产法》第41条',
  },
  {
    name: '未对工艺装置定时巡检，无巡检记录',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  // 工艺装置区
  {
    name: '站内爆炸危险厂房、工艺装置区未设置固定式可燃气体探测器',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '爆炸危险区域内电气、仪表装置不具备相应防爆性能',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '爆炸危险区域内电气防爆隔离密封措施不完整，电缆和接线盒处破损有空隙',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '调压后管道未设置安全阀',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '安全阀未垂直安装，铅封不完整，或无检验标牌',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '调压装置未设置紧急切断阀',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '门站进站、出站管道未设置紧急切断阀',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '过滤器未定期排污，前后压差不符合工艺要求',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  {
    name: '加臭装置运行不合格，加臭剂有泄漏，无加臭量检测及运行记录',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '放散管管口高度不符合规范要求（调压柜放散管管口距地面小于4m）',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '压力表在最高工作压力处无红线标记，或表盘损坏、模糊',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  {
    name: '设备、管道、阀门、法兰等处锈蚀较严重',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  {
    name: '工艺装置接地线不全或连接不完整',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  {
    name: '管道无流向标识，阀门未悬挂开关状态标志牌',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  {
    name: '管道出入地面处有塌陷',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设施运行、维护和抢修安全技术规程》CJJ 51-2016',
  },
  // 检测检验
  {
    name: '压力容器、管道无使用登记证或全面检验报告超期',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016 §7.5',
  },
  {
    name: '安全阀校验报告超期或未校验',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: 'TSG 21-2016',
  },
  {
    name: '防雷、防静电检测合格报告不在有效期内',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《防雷减灾管理办法》',
  },
  {
    name: '可燃气体检测报警器未检定或检定证书超期',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《计量法》',
  },
  {
    name: '防爆电气检测合格证未在有效期内',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《爆炸危险环境电力装置设计规范》GB 50058',
  },
  {
    name: '压力仪表检定证书未在有效期内',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.MAJOR,
    isCustom: false,
    regulatoryBasis: '《计量法》',
  },
  {
    name: '气质检测报告缺失（无自检、委托检验或供气单位提供的检测报告）',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《城镇燃气设计规范》GB 50028',
  },
  {
    name: '灭火器压力指针不在绿色区域或无定期检查记录',
    checkType: CheckType.GATE_PRESSURE,
    hazardLevel: HazardLevel.GENERAL,
    isCustom: false,
    regulatoryBasis: '《建筑灭火器配置设计规范》GB 50140',
  },
]

// 生成完整的隐患项目列表
export function getHazardItems(checkType: CheckType): CheckItem[] {
  const hazardMap: Record<CheckType, Omit<CheckItem, 'id' | 'createdAt'>[]> = {
    [CheckType.LIQUEFIED_GAS]:    liquefiedGasHazards,
    [CheckType.NATURAL_GAS]:      naturalGasHazards,
    [CheckType.LPG_DEPOT]:        lpgDepotHazards,
    [CheckType.LNG_GASIFICATION]: lngGasificationHazards,
    [CheckType.LNG_FILLING]:      lngFillingHazards,
    [CheckType.GATE_PRESSURE]:    gatePressureHazards,
  }

  return (hazardMap[checkType] ?? []).map(hazard => ({
    ...hazard,
    id: uuidv4(),
    createdAt: new Date(),
  }))
}

// 获取所有内置隐患项目
export function getAllHazardItems(): CheckItem[] {
  return [
    ...liquefiedGasHazards,
    ...naturalGasHazards,
    ...lpgDepotHazards,
    ...lngGasificationHazards,
    ...lngFillingHazards,
    ...gatePressureHazards,
  ].map(hazard => ({
    ...hazard,
    id: uuidv4(),
    createdAt: new Date(),
  }))
}
